import React from 'react';
import LayoutSwitcher from './layouts/layout-switcher';
import { Direction } from './containers/direction';
import { widgetWrapper } from './worker/widgetWrapper';
import { createStore } from './widget.store';
import { useConfigBridge } from './utils/useConfigBridge';
import { reinitializeWidget } from './redux/initial-data-desktop';
import { WidgetWidthProvider } from './containers/widget-width';
import { useLoadMadeFor } from './utils/useLoadMadeFor';
import { WindowSize } from './containers/window-size';
import { WidgetFocusProvider } from './containers/WidgetFocus';

function Component() {
  useConfigBridge(reinitializeWidget);
  useLoadMadeFor();

  return (
    <WidgetFocusProvider>
      <WindowSize>
        <WidgetWidthProvider>
          <Direction>
            <LayoutSwitcher />
          </Direction>
        </WidgetWidthProvider>
      </WindowSize>
    </WidgetFocusProvider>
  );
}

export const DesktopWidgetComponent = widgetWrapper({
  createStore,
  Component,
});
